import React from 'react';

export function EmptyState({ icon, title, description, action }) {
  return (
    <div style={{ display: 'grid', justifyContent: 'center', textAlign: 'center', gap: '12px', padding: '56px 24px', color: 'var(--text-muted)' }}>
      {icon && <div style={{ fontSize: 36, color: 'var(--border-strong)', margin: '0 auto' }}>{icon}</div>}
      <h3 style={{ fontSize: 'var(--fs-display-sm)', fontWeight: 600, color: 'var(--text-1)' }}>{title}</h3>
      {description && <p style={{ fontSize: 'var(--fs-body-md)', maxWidth: '380px', margin: '0 auto' }}>{description}</p>}
      {action}
    </div>
  );
}
